import React from 'react';
import { connect } from 'react-redux';
import {
  addIngredientsConfirmAddItems,
  onSaveRecipes,
  onSaveRecipesAllOutlet,
  onUpdateRecipes,
  onUpdateRecipesAllOutlet,
} from 'actions/ingredients/recipes';
import { getFormValues } from 'redux-form';
import { error } from 'actions/notifications';
import styles from './RecipesDetail.css';
import RecipesForm from './RecipesForm';
import AddItemsModal from './AddItemsModal';

class RecipesDetail extends React.Component {
  render() {
    return (
      <div className={styles.wrapper}>
        <div className={styles['form-wrapper']}>
          <RecipesForm onSubmit={this._onSubmit} />
          <AddItemsModal onSubmit={this._onSubmitAddItems} />
        </div>
      </div>
    );
  }

  _onSubmitAddItems = addIngredientsFormValues => {
    const { recipesForm } = this.props;
    this.props.dispatch(
      addIngredientsConfirmAddItems(
        addIngredientsFormValues,
        recipesForm.recipes
      )
    );
  };

  _onSubmit = values => {
    const {
      dispatch,
      recipes,
      itemsDropdowns,
      itemVariant,
      search,
      business,
    } = this.props;
    const { action, itemVariantTemp } = values;
    delete values.action;
    delete values.itemVariantTemp;
    const allVariantIsRecipes = this._allVariantIsrecipes(itemVariantTemp);
    const varID = `${values.item_variant_id}`;
    if (!values.id) {
      if (!values.item_id) {
        // when user not select a item
        dispatch(error('Please add Item.'));
      } else if (!values.recipe_ingredients.length) {
        // when user not add a ingredient
        dispatch(error('Please add Ingredients'));
      } else if (
        itemVariantTemp.length === 1 &&
        itemVariantTemp[0].name === 'No Variant' &&
        itemVariantTemp[0].is_recipe
      ) {
        // when item is an recipe
        dispatch(error('This item has been used for recipe.'));
      } else if (
        (!values.item_variant_id ||
          values.item_variant_id === 'Variant Option') &&
        allVariantIsRecipes &&
        itemVariantTemp[0].name !== 'No Variant'
      ) {
        // when all item variant is an recipe
        dispatch(error('All variants for this item has been used for recipe.'));
      } else if (
        (!values.item_variant_id ||
          values.item_variant_id === 'Variant Option') &&
        !allVariantIsRecipes &&
        itemVariantTemp[0].name !== 'No Variant'
      ) {
        // when user not select an item variant
        dispatch(error('Please add item variant.'));
      } else {
        if (!values.item_variant_id) {
          values.item_variant_id = itemVariantTemp[0].value;
        }
        if (itemVariant.length === 1) {
          values.sku = itemVariant[0].sku;
        } else {
          itemVariant.forEach(iv => {
            const ivID = `${iv.value}`;
            if (ivID === varID) {
              values.sku = iv.sku;
            }
          });
        }
        // force value to update item_name because redux-form won't update its form reducers
        itemsDropdowns.forEach(item => {
          if (item.id === values.item_id) values.item_name = item.label;
        });

        if (action === 'save') {
          dispatch(onSaveRecipes(values, recipes));
        } else if (action === 'save_to_all_outlet') {
          if (values.item_variant_name === null) {
            values.item_variant_name = '';
          }
          values.recipe_ingredients.map(function(recipe) {
            recipe.id = recipe.ingredient_id;
          });
          dispatch(onSaveRecipesAllOutlet(values, recipes));
        }
      }
    } else {
      if (!values.item_variant_id) {
        values.item_variant_id = itemVariantTemp[0].value;
      }
      if (!values.recipe_ingredients.length) {
        // when user not add a ingredient
        dispatch(error('Please add Ingredients'));
      } else {
        [values.outlet_id] = search.outletIds;
        values.business_id = business.id;
        if (action === 'update') {
          dispatch(onUpdateRecipes(values, recipes));
        } else if (action === 'update_to_all_outlet') {
          if (values.item_variant_name === 'No Variant') {
            values.item_variant_name = '';
          }
          dispatch(onUpdateRecipesAllOutlet(values, recipes));
        }
      }
    }
  };

  _allVariantIsrecipes = itemVariant => {
    let result = true;
    if (itemVariant.length > 1) {
      itemVariant.map(function(item) {
        if (!item.is_recipe && item.value !== 'Variant Option') {
          result = false;
        }
      });
    }
    return result;
  };
}

function mapStateToProps(state) {
  const {
    recipes,
    recipesDetail,
    showAddItemsModal,
    ingredientRecipesDetail,
    itemsDropdowns,
    itemVariant,
  } = state.ingredients.recipes;
  const {
    user: { business },
  } = state.moka;
  return {
    recipes,
    recipesDetail,
    showAddItemsModal,
    ingredientRecipesDetail,
    itemVariant,
    recipesForm: getFormValues('recipes')(state),
    search: getFormValues('search')(state),
    business,
    itemsDropdowns,
  };
}

export default connect(mapStateToProps)(RecipesDetail);
